import { Stack, Typography } from "@mui/material";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import * as React from "react";

export const StatsCards = (props) => {
  const { data } = props;
  const colors = [
    "#A04D3D",
    "#5E7360",
    "#564845",
    "#9A8260",
    "#A04D3D",
    "#5E7360",
    "#564845",
    "#9A8260",
  ];

  const formatValue = (value) => {
    if (value.type === "currency") {
      return `$${value.current}`;
    }
    const numeric = Number(value.current);
    return Number.isFinite(numeric) ? numeric.toLocaleString() : value.current;
  };

  return (
    <Stack
      sx={{
        flexDirection: "row",
        rowGap: "24px",
        columnGap: "38px",
        flexWrap: "wrap",
        mb: "24px",
      }}
    >
      {data?.map((value, i) => {
        const progress = Number(value.progress);
        const hasProgress = Number.isFinite(progress);
        const isUp = progress > 0;
        const isDown = progress < 0;
        return (
          <Stack
            key={i}
            sx={{
              flexDirection: "row",
              gap: "24px",
              justifyContent: "space-between",
              backgroundColor: colors[i],
              borderRadius: "8px",
              padding: "16px",
              minWidth: "calc(25% - 28.5px)",
              color: "#fff",
              // flexGrow:'1'
            }}
          >
            <Stack gap="8px">
              <Typography variant="h5" lineHeight="29px">
                {formatValue(value)}
              </Typography>
              <Typography fontWeight="600" lineHeight="19px">
                {value.label}
              </Typography>
            </Stack>
            {/* signed so the direction reads even without the arrow */}
            {hasProgress && (
              <Stack
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "4px",
                  height: "20px",
                }}
              >
                {isUp && <ArrowUpwardRoundedIcon sx={{ fontSize: 16 }} />}
                {isDown && <ArrowDownwardRoundedIcon sx={{ fontSize: 16 }} />}
                <Typography lineHeight="19px" fontWeight={600}>
                  {isUp ? "+" : ""}
                  {progress}%
                </Typography>
              </Stack>
            )}
          </Stack>
        );
      })}
    </Stack>
  );
};
